import { render, staticRenderFns } from "./ResponsableAgregar.vue?vue&type=template&id=47e9ca41"
import script from "./ResponsableAgregar.vue?vue&type=script&lang=js"
export * from "./ResponsableAgregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports